import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { catchError, mergeMap, take } from 'rxjs/operators';
import { UserResponse } from '../services/auth/responses/user.response';
import { ILocalStorageService, LOCAL_STORAGE_SERVICE_TOKEN } from '../services/local-storage/local-storage-service.interface';
import { AUTH_SERVICE_TOKEN, IAuthService } from '../services/auth/auth-service.interface';

@Injectable()
export class UserResolverService  {
  constructor(
    @Inject(LOCAL_STORAGE_SERVICE_TOKEN) private localStorageService: ILocalStorageService,
    @Inject(AUTH_SERVICE_TOKEN) private authService: IAuthService,
    private router: Router
  ) {}

  resolve(): Observable<UserResponse> {
    const userData = this.authService.getUserData();
    if (userData) {
      return of(userData);
    }
    return this.authService.loadUser().pipe(
      take(1),
      mergeMap((user) => (user ? of(user) : throwError('no user'))),
      catchError(() => {
        this.localStorageService.removeItem('token');
        this.router.navigate(['/']);
        return of(null);
      })
    );
  }
}
